import { store } from '../redux/store';
import * as actions from '../redux/action';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const globalLogout = (history, TYPE) => {
    const state = store.getState();
    const { getLoginRole } = state;
    const user = getLoginRole && getLoginRole.user && getLoginRole.user.role;

    if (user === 'privateScreeningPartner') {
        history.push('/ps-signin');
    } else if (TYPE !== 'FORCE') {
        history.push('/');
    }

    store.dispatch(actions.LoginToken(""));
    store.dispatch(actions.LoginRole(""));
    store.dispatch(actions.LoginUser(''));
    store.dispatch(actions.GetPartner(""));
    store.dispatch(actions.GetPartnerEvent(""));
    store.dispatch(actions.GetSatellite(""));
    store.dispatch(actions.GetSatelliteEvent(""));
    store.dispatch(actions.LoginAdminByID(""));
    store.dispatch(actions.ProfileName(""));
    store.dispatch(actions.BackToAdminPreviousPath(''));
    
    // Cookie clearing from App.js
    document.cookie = (!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT +"SessionLogout" : "SessionLogout") + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "SessionLogout" : "SessionLogout", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });

    localStorage.clear();
    
    store.dispatch(actions.BackToAdminFlag(false));
    store.dispatch(actions.ShortProgramEditData(''));
    store.dispatch(actions.EpisodicShortProgramEditData(''));
    store.dispatch(actions.filmEditData(''));
    store.dispatch(actions.TalkEventEditData(''));
    store.dispatch(actions.OtherEventsEditData(''));
    store.dispatch(actions.NewFrontierEditData(''));
    store.dispatch(actions.LiveSceeringEditData(''));
    store.dispatch(actions.CurrentTab(''));
    store.dispatch(actions.CurrentShortTab(''));

    if (TYPE === 'FORCE') {
        window.location.reload();
    }
    // this.apiserve.success('Logout successful.');
};
